"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("../../../components");
var _ = require("../..");
var _utils = require("../../../utils");
var _lodash = require("lodash");
var _PhoneNumberVerification = require("../../PhoneNumberVerification");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SuccessRegisterContent = function SuccessRegisterContent(_ref) {
  var _savedGroupNotificati;
  var close = _ref.close;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user,
    refreshUser = _useAuth.refetchUser;
  var profile = user.profile;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    isPhoneVerificationVisible = _useState2[0],
    setIsPhoneVerificationVisible = _useState2[1];
  // wrapped in useMemo to provide only initial values, not considering reloaded one
  var isPhoneProvided = (0, _react.useMemo)(function () {
    return !!(profile !== null && profile !== void 0 && profile.phoneNumber);
  }, []);
  var _useRequest = (0, _utils.useRequest)((0, _utils.getPatientNotificationPreferencesUrl)('me')),
    preferences = _useRequest.data,
    loadingPreferences = _useRequest.loading,
    refreshPreferences = _useRequest.refresh;
  var savedGroupNotificationPreference = (0, _react.useMemo)(function () {
    return preferences === null || preferences === void 0 ? void 0 : preferences.find(function (_ref2) {
      var notificationGroup = _ref2.notificationGroup;
      return notificationGroup === 'group';
    });
  }, [preferences]);
  var _useRequest2 = (0, _utils.useRequest)(function (groupNotificationPreference) {
      return {
        url: (0, _utils.getPatientNotificationPreferencesUrl)('me'),
        method: 'post',
        data: {
          preferences: [{
            notificationGroup: 'group',
            id: groupNotificationPreference === null || groupNotificationPreference === void 0 ? void 0 : groupNotificationPreference.id,
            channels: (0, _lodash.uniq)([].concat(_toConsumableArray((groupNotificationPreference === null || groupNotificationPreference === void 0 ? void 0 : groupNotificationPreference.channels) || []), ['SMS']))
          }]
        }
      };
    }, {
      manual: true,
      onSuccess: refreshPreferences
    }),
    updatingPreferences = _useRequest2.loading,
    updatePreferences = _useRequest2.run;
  var _useSendPhoneVerifica = (0, _utils.useSendPhoneVerificationCode)({
      onSuccess: function onSuccess() {
        setIsPhoneVerificationVisible(true);
      }
    }),
    onSendPhoneVerificationCode = _useSendPhoneVerifica.onSend,
    sendingPhoneVerificationCode = _useSendPhoneVerifica.sending;
  var phoneNumberError = (0, _react.useMemo)(function () {
    return profile && (0, _utils.phoneNumberSMSCompatibilityError)({
      phoneType: profile.phoneType,
      phoneSmsCompatible: profile.phoneSmsCompatible,
      phoneDeliveryPreference: profile.phoneDeliveryPreference,
      phoneStatus: profile.phoneStatus
    });
  }, [profile]);
  var onSubmitGettingNotifications = function onSubmitGettingNotifications() {
    updatePreferences(savedGroupNotificationPreference);
    refreshUser();
    close();
  };
  var isInitialLoad = !preferences && loadingPreferences;
  if (isInitialLoad) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  var dataNotInitiallyLoaded = !preferences && !loadingPreferences;
  if (dataNotInitiallyLoaded) {
    return null;
  }
  var isSmsGroupNotificationsEnabled = savedGroupNotificationPreference === null || savedGroupNotificationPreference === void 0 ? void 0 : (_savedGroupNotificati = savedGroupNotificationPreference.channels) === null || _savedGroupNotificati === void 0 ? void 0 : _savedGroupNotificati.includes('SMS');
  var isPhoneProvidedAndSmsCompatible = isPhoneProvided && !phoneNumberError;
  var onGetSmsNotifications = function onGetSmsNotifications() {
    if (!isPhoneProvided) {
      setIsPhoneVerificationVisible(true);
    } else if (!isPhoneProvidedAndSmsCompatible) {
      onSendPhoneVerificationCode({
        phoneNumber: profile === null || profile === void 0 ? void 0 : profile.phoneNumber
      });
    } else {
      onSubmitGettingNotifications();
    }
  };
  if (isPhoneVerificationVisible) {
    return /*#__PURE__*/_react.default.createElement(_PhoneNumberVerification.PhoneNumberVerificationWidget, {
      phoneNumber: profile === null || profile === void 0 ? void 0 : profile.phoneNumber,
      includePhoneInputStep: !isPhoneProvided,
      onSuccess: function onSuccess() {
        onSubmitGettingNotifications();
      },
      onPhoneNumberUpdated: function onPhoneNumberUpdated() {
        refreshUser();
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-[40px] flex flex-col items-center"
  }, /*#__PURE__*/_react.default.createElement(_components.Lottie, {
    type: "register-checkmark-green",
    width: 80,
    height: 80
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium text-black py-[18px] md:tw-subtitle-lg-medium"
  }, "You\u2019re all set!"), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-light text-center md:tw-body-lg-light mx-[20px]"
  }, "Keep an eye out for a confirmation email that includes links to add the event to your calendar and directions for joining the session.")), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "border-grey-20 mt-[15px] mx-[-20px]"
  }), /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: sendingPhoneVerificationCode || updatingPreferences
  }, isPhoneProvidedAndSmsCompatible && isSmsGroupNotificationsEnabled ? /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row justify-center py-[24px] mx-[-20px] md:pt-[32px] md:pb-[12px]"
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    className: "w-[327px] h-[46px] md:w-[392px] label-small-medium",
    onClick: close
  }, "Continue")) : /*#__PURE__*/_react.default.createElement("div", {
    className: "py-[24px] mx-[-20px] md:pt-[32px] md:pb-[12px]"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-label-medium text-center text-black mb-[20px] mx-[20px]"
  }, "Get SMS reminders on your phone?"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-around"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    onClick: function onClick() {
      close();
    },
    className: "w-[196px]",
    size: "large"
  }, "No, thanks"), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    onClick: onGetSmsNotifications,
    className: "w-[196px]",
    size: "large"
  }, "Confirm")))));
};
SuccessRegisterContent.propTypes = {
  close: _propTypes.default.func
};
var _default = SuccessRegisterContent;
exports.default = _default;